import { attr, Model } from 'redux-orm';
import { createAction, createLoadConst } from '../util';

export default class InternalAccountAudit extends Model {
  static get modelName() {
    return 'InternalAccountAudit';
  }

  static reducer({ type, data }, InternalAccountAudit) {
    switch (type) {
      case LOAD.SUCCESS:
        InternalAccountAudit.delete();
        if (data.response) {
          data.response.forEach((r) => InternalAccountAudit.upsert(r));
        }
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      byAdminUserId: attr(),
      bySystemUser: attr(),
      byUserId: attr(),
      changelog: attr(),
      ddaId: attr(),
      id: attr(),
      logAt: attr(),
      logOp: attr(),
      time: attr(), // derived
      title: attr(), // derived
    };
  }
}

export const LOAD = createLoadConst(InternalAccountAudit.modelName);
export const load = createAction(LOAD);
